export default __webpack_public_path__ + "static/media/749.08a8e111.gif";